import {
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  POST_NOTIFICATIONS_MARK_REQUEST,
  POST_NOTIFICATIONS_MARK_SUCCESS,
  POST_NOTIFICATIONS_MARK_FAILURE,
  GET_NOTIFICATIONS_LATEST_REQUEST,
  GET_NOTIFICATIONS_LATEST_SUCCESS,
  GET_NOTIFICATIONS_LATEST_FAILURE,
  TOGGLE_SYSTEM_NOTIFICATION_DIALOG,
  TOGGLE_RECOMMEND_RELOCATION_PERSONNEL_NOTIFICATION_DIALOG,
  LOG_OUT_SUCCESS,
} from "../../constants/ActionTypes";

const { OrderedMap } = require("immutable");

const initialState = {
  isLoadingNotifications: false,
  latest_notifications: OrderedMap({}),
  isLoadingNotificationsLatest: false,
  notifications: OrderedMap({}),
  pageInfo: null,
  showSystemNotificationDialog: false,
  showRecommendRelocationPersonnelNotificationDialog: false,
  notification_item: null,
};

export default (state = initialState, action) => {
  let list, notification_item, notification_latest_item;

  switch (action.type) {
    case GET_NOTIFICATIONS_LATEST_REQUEST:
      return {
        ...state,
        isLoadingNotificationsLatest: true,
      };
    case GET_NOTIFICATIONS_LATEST_SUCCESS:
      list = OrderedMap({});

      action.payload.notifications.forEach((item) => {
        list = list.set(item.id, item);
      });

      return {
        ...state,
        isLoadingNotificationsLatest: false,
        latest_notifications: list,
      };
    case GET_NOTIFICATIONS_LATEST_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        isLoadingNotificationsLatest: false,
      };
    case GET_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isLoadingNotifications: true,
      };
    case GET_NOTIFICATIONS_SUCCESS:
      list = OrderedMap({});

      action.payload.notifications.forEach((item) => {
        list = list.set(item.id, item);
      });

      return {
        ...state,
        isLoadingNotifications: false,
        notifications: list,
        pageInfo: action.payload.pageInfo,
      };
    case GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        isLoadingNotifications: false,
      };
    case POST_NOTIFICATIONS_MARK_REQUEST:
      notification_item = state.notifications.get(action.payload.id);
      notification_latest_item = state.latest_notifications.get(
        action.payload.id
      );

      return {
        ...state,
        notifications: notification_item
          ? state.notifications.set(notification_item.id, {
            ...notification_item,
            read_flag: 1,
          })
          : state.notifications,
        latest_notifications: notification_latest_item
          ? state.latest_notifications.set(notification_latest_item.id, {
            ...notification_latest_item,
            read_flag: 1,
          })
          : state.latest_notifications,
      };
    case POST_NOTIFICATIONS_MARK_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.has(action.payload.notification.id)
          ? state.notifications.set(
            action.payload.notification.id,
            action.payload.notification
          )
          : state.notifications,
        latest_notifications: state.latest_notifications.has(
          action.payload.notification.id
        )
          ? state.latest_notifications.set(
            action.payload.notification.id,
            action.payload.notification
          )
          : state.latest_notifications,
      };
    case POST_NOTIFICATIONS_MARK_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    case TOGGLE_SYSTEM_NOTIFICATION_DIALOG:
      return {
        ...state,
        showSystemNotificationDialog: !state.showSystemNotificationDialog,
        notification_item: action.payload.item,
      };
    case TOGGLE_RECOMMEND_RELOCATION_PERSONNEL_NOTIFICATION_DIALOG:
      return {
        ...state,
        showRecommendRelocationPersonnelNotificationDialog: !state.showRecommendRelocationPersonnelNotificationDialog,
        notification_item: action.payload.item,
      };
    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/notification.js